<template>
  <!-- The paint form's drawings (2026-10-30): the eight mood scenes, the plain
       night and the seven art-style filters, mounted once as hidden SVG defs.
       The mood tiles, the style samples and the lit room all point here.
       Not display:none, which would switch the filters and gradients off. -->
  <svg class="apf-defs" :class="{ 'apf-rm': reduced }" width="0" height="0" aria-hidden="true" focusable="false">
    <defs v-html="DEFS"></defs>
  </svg>
</template>

<script setup>
import { useReducedMotion } from '@/composables/useReducedMotion'
import { allDefs } from '@/utils/altar-scenes'

const DEFS = allDefs()
const reduced = useReducedMotion()
</script>

<style>
/* Global on purpose: <use> draws these symbols in their own trees, where
   scoped styles never reach; every name is prefixed apf-. */
.apf-defs { position: absolute; width: 0; height: 0; overflow: hidden; pointer-events: none; }

/* The live preview's light, registered so the gradients glide between moods
   (no @property support is an instant switch, which is fine). */
@property --m1 { syntax: '<color>'; inherits: true; initial-value: #3a1708; }
@property --m2 { syntax: '<color>'; inherits: true; initial-value: #120610; }
@property --m3 { syntax: '<color>'; inherits: true; initial-value: #ffb347; }
@property --m4 { syntax: '<color>'; inherits: true; initial-value: #e9a65a; }

/* Loops, full motion only: flames flicker, stars twinkle, the waves drift. */
.apf-fl { transform-box: fill-box; transform-origin: 50% 100%; animation: apf-flick 3.2s ease-in-out infinite; }
.apf-fl:nth-of-type(2n) { animation-duration: 2.7s; animation-delay: -.8s; }
.apf-fl:nth-of-type(3n) { animation-duration: 3.7s; animation-delay: -1.9s; }
.apf-tw { animation: apf-twinkle 3.4s ease-in-out infinite; }
.apf-tw:nth-of-type(3n) { animation-delay: -1.2s; }
.apf-tw:nth-of-type(4n) { animation-delay: -2.3s; animation-duration: 4.4s; }
.apf-drift { animation: apf-drift 7s ease-in-out infinite alternate; }
@keyframes apf-flick { 0%, 100% { transform: scale(1, 1) skewX(0); } 30% { transform: scale(.96, 1.05) skewX(-2deg); } 62% { transform: scale(1.03, .95) skewX(1.5deg); } }
@keyframes apf-twinkle { 50% { opacity: .15; } }
@keyframes apf-drift { to { transform: translateX(-6px); } }

/* Reduced motion: nothing loops. */
.apf-rm .apf-fl, .apf-rm .apf-tw, .apf-rm .apf-drift { animation: none !important; }
@media (prefers-reduced-motion: reduce) {
  .apf-fl, .apf-tw, .apf-drift { animation: none !important; }
}
</style>
